import type { CoreModuleOptions } from '../types'
import type { Merge } from 'type-fest'
import type * as Theme from '#theme'
import { useRuntimeConfig } from '#imports'

export const useCoreConfig = () => {
    const config = useRuntimeConfig()

    return config.public.core as unknown as
        Merge<CoreModuleOptions, {
            theme: Theme.Configuration
        }>
}
